// Dog-friendly recommendations for the FAQ page section.
// Distances are approximate, measured from the Wilton Manors homes at 1425 NE 24th St.
// Rules verified against official city/state pages in October 2026 — each venue links
// to its official site so guests can confirm current rules before visiting.
export const dogFriendly = [
  {
    h: "Dog-Friendly Beaches",
    items: [
      {
        name: "Fort Lauderdale Canine Beach",
        url: "https://www.parks.fortlauderdale.gov/parks/dog-friendly-places",
        distance: "about a 15-minute drive",
        detail:
          "The city's designated dog beach on A1A. A permit is required — visiting pups can get a short-term permit from the Parks office at Holiday Park (bring vaccination records) — dogs stay leashed, and posted hours are Friday to Sunday afternoons.",
      },
    ],
  },
  {
    h: "Waterfront Walks",
    items: [
      {
        name: "Richardson Historic Park & Nature Preserve",
        url: "https://www.wiltonmanors.gov/163/Richardson-Historic-Park-Nature-Preserve",
        distance: "about a 10-minute walk",
        detail:
          "Riverside trails along the Middle River, open 8am to dusk. Dogs stay on a 6-ft leash and out of the water features.",
      },
      {
        name: "Stafford Park Nature Preserve",
        url: "https://wiltonmanors.gov/160/Stafford-Park-Nature-Preserve",
        distance: "about a 15-minute walk",
        detail: "A quiet boardwalk loop through the mangroves — leashed pups welcome.",
      },
      {
        name: "Island City Park Preserve",
        url: "https://www.wiltonmanors.gov/155/City-Parks",
        distance: "about a 5-minute drive",
        detail: "Shaded walking paths; keep pups leashed (6 ft max) and clear of playgrounds and waterways.",
      },
      {
        name: "Riverwalk Fort Lauderdale",
        url: "https://www.goriverwalk.com",
        distance: "about a 12-minute drive",
        detail: "The breezy downtown riverfront promenade — leashed dogs are welcome along the whole stretch.",
      },
    ],
  },
  {
    h: "Dog Parks",
    items: [
      {
        name: "Colohatchee Park and Dog Park",
        url: "https://www.wiltonmanors.gov/681/Colohatchee-Dog-Park",
        distance: "about a 5-minute drive",
        detail:
          "Wilton Manors' own off-leash dog park. Entry requires a city permit (key fob) with proof of rabies and bordetella vaccinations, and the park is closed on Tuesdays.",
      },
      {
        name: "Donn Eisele Park",
        url: "https://www.wiltonmanors.gov/158/Donn-Eisele-Park",
        distance: "about a 5-minute drive",
        detail: "Neighborhood green space for leashed strolls, open Tuesday to Sunday, 8am to dusk.",
      },
      {
        name: "Holiday Park Dog Park",
        url: "https://www.parks.fortlauderdale.gov/parks/parks/holiday-park",
        distance: "about a 10-minute drive",
        detail:
          "A big fenced off-leash area inside Fort Lauderdale's Holiday Park (open 6am to 11pm). Parts of the park are under construction in 2026 — check the city page for current status.",
      },
    ],
  },
  {
    h: "Pet-Friendly Patios",
    items: [
      {
        name: "Rosie's Bar & Grill",
        url: "https://www.rosiesbarandgrill.com",
        distance: "about a 10-minute walk",
        detail:
          "A Wilton Drive institution with a big garden patio that welcomes dogs — ask for a patio table at busy times.",
      },
      {
        name: "Sidelines",
        url: "https://wiltondrive.org/sidelines/",
        distance: "about an 8-minute walk",
        detail: "Sports bar with a shaded patio; small, well-mannered pets are welcome outside.",
      },
      {
        name: "Union Kitchen & Bar",
        url: "https://www.unionkb.com",
        distance: "about a 4-minute drive",
        detail: "Craft cocktails and a pet-friendly back patio on N Dixie Hwy.",
      },
    ],
  },
  {
    h: "Explore Wilton Drive",
    items: [
      {
        name: "Wilton Drive",
        url: "https://wiltondrive.org",
        distance: "about a 10-minute walk",
        detail:
          "The whole strip is an open-air, dog-loving stroll — patios, shops, rainbow crosswalks and plenty of water bowls outside local businesses.",
      },
    ],
  },
  {
    h: "More Dog-Friendly Outings",
    items: [
      {
        name: "Hugh Taylor Birch State Park",
        url: "https://www.floridastateparks.org/parks-and-trails/hugh-taylor-birch-state-park",
        distance: "about a 12-minute drive",
        detail:
          "Shaded hammock trails across from the ocean. Dogs are welcome on a hand-held 6-ft leash in designated areas, but not on the beach itself.",
      },
    ],
  },
];
